import { toast } from "react-toastify";
import { BasicPage } from "../../../theme/Component/BasicPage"
import { ListMenu } from "../../../theme/Component/ListMenu";
import { useEffect, useState } from "react";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { BasicTable, MASK_DATE } from "../../../theme/Component/BasicTable";
import { Modal } from "../../../theme/Component/Modal";
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import { BasicButton } from "../../../theme/Component/BasicButton";
import useModal, { MODAL_md, MODAL_XL } from "../../../theme/Component/hooks/useModal";
import { _PlanMaintenance, _single } from "../../../../core/services/dataBean/EntityCatalog";
import { InputDate } from "../../../theme/Input/InputDate";
import { ScheduleMaintenance } from "./ScheduleMaintenance/ScheduleMaintenance";
import { PlanMaintenanceArea } from "./PlanMaintenanceArea/PlanMaintenanceArea";

interface Form {
    State: number;
    Location: number;
}

export const PlanMaintenance = () => {

    const { instance, bean, setBean, lista, setLista } = useDataBean(_PlanMaintenance);
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modalC, setModalC] = useState<any>({ name: 'Eliminar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });
    const [form, setForm] = useState<Partial<Form>>({});
    const modalRequest = useModal("Mantenimientos Programados", MODAL_XL);
    const modalUpdate = useModal("Actualizar estado del Plan", MODAL_md);

    useEffect(() => {
        getLista();
    }, [])

    const getLista = () => {
        const props = {
            State: form.State,
            IDLocation: form.Location
        }
        instance.getPlanMaintenanceCatalogPorPropiedades(props, null).then(
            (resp: any) => {
                if (resp) {
                    resp.forEach(plan => {
                        if (!plan.DataBeanProperties) {
                            plan.DataBeanProperties = {};
                        }
                        const mplan = plan.DataBeanProperties;

                        mplan.RenderState = renderState(mplan.State)
                    });
                    setLista(resp)
                }
            }
        )
    }

    const create = () => {
        setBean({
            State: 1,
            IDEmployee: _single.getAccountID(),
        });
        setModal({ ...modal, "name": `Agregar Plan de Mantenimientos`, "view": true });
    }

    const deleteItem = () => {
        const x = { ...bean, State: 4 };
        editaItem(x);
        setModalC({ ...modalC, view: false });
    };

    const editaItem = (obj: any) => {
        instance.updatePlanMaintenance(obj).then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
                modalUpdate.close();
            }
        ).catch(err => {
            toast.error(err);
        })
    }

    const renderState = (State: number) => {
        switch (State) {
            case 1:
                return "Creado";
            case 2:
                return "En Ejecución";
            case 3:
                return "Finalizado";
            case 4:
                return "Cancelado";
        }
    }

    const head = [
        { title: 'ID', property: 'IDPlanMaintenance', visible: true },
        { title: 'Nombre del Plan', property: 'PlanName', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
        { title: 'Fecha desde', property: 'PlanDateFrom', visible: true, mask: MASK_DATE },
        { title: 'Fecha hasta', property: 'PlanDateTo', visible: true, mask: MASK_DATE },
        { title: 'Estado', property: 'RenderState', visible: true },
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]

    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: _single.canEdit() && bean.State === 1, evento: () => { setModal({ ...modal, "name": `Editar ${bean.PlanName}`, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: _single.canDelete() && bean.State === 1, evento: () => { setModalC({ ...modalC, "view": true }) } },
            { titulo: 'Mantenimientos Programados', icono: 'ri-settings-5-fill', visible: true, evento: () => { modalRequest.open() } },
            { titulo: 'Cambiar Estado', icono: 'ri-exchange-line', visible: true, evento: () => { modalUpdate.open() } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    return (
        <BasicPage titulo="Planes de Mantenimiento">
            <div className="row">
                <div className="col-md-5">
                    <label>Estado</label>
                    <select className="form-select" value={form.State} onChange={(e) => {
                        const value = e.target.value ? Number(e.target.value) : null;
                        setForm({ ...form, State: value })
                    }} >
                        <option value="">...</option>
                        <option value={1}>Creado</option>
                        <option value={2}>En Ejecución</option>
                        <option value={3}>Finalizado</option>
                        <option value={4}>Cancelado</option>
                    </select>
                </div>
                <div className="col-md-2 mt-4">
                    <BasicButton eventClick={getLista} icon="ri-search-line" children={"buscar"} />
                </div>
                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem} />

                    <Modal modal={modal} updateModal={setModal} eventModal={() => { editaItem(bean) }}>
                        <div className="row">
                            <div className="col-md-6">
                                <InputDate name="PlanDateFrom" value={bean.PlanDateFrom} setDate={(e) => { setBean({ ...bean, PlanDateFrom: e }) }} label="Fecha de Inicio" />
                            </div>
                            <div className="col-md-6">
                                <InputDate name="PlanDateTo" value={bean.PlanDateTo} setDate={(e) => { setBean({ ...bean, PlanDateTo: e }) }} label="Fecha de Finalización" />
                            </div>
                            <div className="col-md-12">
                                <label>Nombre del Plan</label>
                                <input type="text" className="form-control" value={bean.PlanName} onChange={(e) => { setBean({ ...bean, PlanName: e.target.value }) }} />
                            </div>
                            <div className="col-md-12">
                                <label>Descripción</label>
                                <textarea className="form-control" value={bean.Description} onChange={(e) => { setBean({ ...bean, Description: e.target.value }) }} />
                            </div>
                        </div>
                    </Modal>

                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item {bean.Description}</strong>
                    </ModalConfirm>

                    <Modal modal={modalRequest.modal} updateModal={modalRequest.setModal} >
                        <div className="row">
                            <div className="col-md-12">
                                <PlanMaintenanceArea _planMaintenance={bean} />
                            </div>
                        </div>
                    </Modal>

                    <Modal modal={modalUpdate.modal} updateModal={modalUpdate.setModal} eventModal={() => { editaItem(bean) }} >
                        <div className="row">
                            <div className="col-md-12">
                                <label>Estado</label>
                                <select className="form-select" value={bean.State} onChange={(e) => {
                                    const value = e.target.value ? Number(e.target.value) : null;
                                    setBean({ ...bean, State: value })
                                }} >
                                    <option value="">...</option>
                                    <option value={1}>Creado</option>
                                    <option value={2}>En Ejecución</option>
                                    <option value={3}>Finalizado</option>
                                    {/* <option value={4}>Cancelado</option> */}
                                </select>
                            </div>
                        </div>
                    </Modal>
                </div>

            </div>
        </BasicPage>
    )
}